// Web Audio ambient drone that intensifies with the crisis level.
// Must be created after a user gesture (browser autoplay policy).

let ctx = null;
let master = null;
let voices = [];
let started = false;
let _muted = false;

// base drone frequencies (a low, unsettling academic hum)
const BASE = [55, 82.5, 110, 164.81];

export function isStarted() {
  return started;
}

export function startAudio() {
  if (started) return;
  const AudioCtx = window.AudioContext || window.webkitAudioContext;
  if (!AudioCtx) return;
  ctx = new AudioCtx();

  master = ctx.createGain();
  master.gain.value = 0.0;
  master.connect(ctx.destination);

  // gentle low-pass to keep it warm
  const lp = ctx.createBiquadFilter();
  lp.type = "lowpass";
  lp.frequency.value = 600;
  lp.connect(master);

  voices = BASE.map((f, i) => {
    const osc = ctx.createOscillator();
    osc.type = i === 3 ? "sawtooth" : "sine";
    osc.frequency.value = f;

    const g = ctx.createGain();
    g.gain.value = i === 3 ? 0.0 : 0.18 / BASE.length;

    // slow detune LFO for movement
    const lfo = ctx.createOscillator();
    lfo.frequency.value = 0.05 + i * 0.03;
    const lfoGain = ctx.createGain();
    lfoGain.gain.value = 1.5;
    lfo.connect(lfoGain);
    lfoGain.connect(osc.detune);

    osc.connect(g);
    g.connect(lp);
    osc.start();
    lfo.start();
    return { osc, g, base: f };
  });

  // fade in — but only if we're not muted (keep oscillators running & silent otherwise)
  if (!_muted) {
    master.gain.linearRampToValueAtTime(0.5, ctx.currentTime + 2.5);
  }
  started = true;
}

// crisis 0..1 -> louder, brighter, dissonant top voice
export function setAudioCrisis(crisis) {
  if (!started || !ctx) return;
  const t = ctx.currentTime;
  // respect the mute state — don't let the crisis driver override volume while muted
  if (!_muted) {
    master.gain.setTargetAtTime(0.35 + crisis * 0.5, t, 0.4);
  }
  // dissonant saw voice swells in during crisis
  const saw = voices[3];
  if (saw) {
    // gate the voice VOLUME behind mute; keep frequency/timbre live so it's ready on unmute
    if (!_muted) {
      saw.g.gain.setTargetAtTime(crisis * 0.14, t, 0.4);
    }
    saw.osc.frequency.setTargetAtTime(164.81 + crisis * 40, t, 0.6);
  }
  // pitch tension across the pad
  voices.slice(0, 3).forEach((v) => {
    v.osc.frequency.setTargetAtTime(v.base * (1 + crisis * 0.06), t, 0.8);
  });
}

export function stopAudio() {
  if (!started || !ctx) return;
  master.gain.setTargetAtTime(0.0001, ctx.currentTime, 0.3);
  setTimeout(() => {
    voices.forEach((v) => {
      try {
        v.osc.stop();
      } catch (e) {}
    });
    ctx.close();
    ctx = null;
    voices = [];
    started = false;
    setMuted(true);
  }, 500);
}

export function setMuted(m) {
  _muted = m;
  if (started && master && ctx) {
    // cancel any competing fade-ins/ramps so mute is authoritative
    master.gain.cancelScheduledValues(ctx.currentTime);
    master.gain.setValueAtTime(master.gain.value, ctx.currentTime);
    master.gain.setTargetAtTime(m ? 0.0001 : 0.5, ctx.currentTime, 0.2);
  }
}
export function isMuted() {
  return _muted;
}
